import React, { useState } from 'react';
import { Box, Tabs, Tab, Select, MenuItem, Grid, Typography, Paper } from '@mui/material';
import WSDateField from '../../Components/DateField/WSDateField';
import { useForm } from 'react-hook-form';

export const BanquetView: React.FC = () => {
    const {control}= useForm();
  const [view, setView] = useState(0);

  const handleChangeView = (event: React.SyntheticEvent, newValue: number) => {
    setView(newValue);
  };

  // Generate time slots in half-hour increments up to 23:59
  const timeSlots = Array.from({ length: 48 }, (_, i) => {
    const hours = Math.floor(i / 2);
    const minutes = i % 2 === 0 ? '00' : '30';
    return `${String(hours).padStart(2, '0')}:${minutes}`;
  });

  return (
    <Grid sx={{ width: '100%', padding: 2, backgroundColor: '#F4F4F4', height: '100vh' }}>
      {/* Tabs for Daily, Weekly, Monthly */}
      <Grid 
        item 
        
        sx={{ display: 'flex',  backgroundColor: '#c4cfe1', borderRadius: 1, maxWidth: '300px', }}
      >
        <Tabs 
          value={view} 
          onChange={handleChangeView} 
          centered
          TabIndicatorProps={{ style: { display: 'none' } }} // Hide default indicator
          sx={{
            width: '100%',
            '& .MuiTab-root': {
              minWidth: '33.33%', // Make tabs equal width
              color: '#000',
              padding: '10px 20px',
              fontWeight: 'bold',
              fontSize: '16px',
              backgroundColor: view === 0 ? '#90a4ae' : '#c4cfe1', // Active color
              '&:not(:last-of-type)': {
                borderRight: '2px solid #000', // Thick border between tabs
              },
            },
          }}
        >
          <Tab label="Daily" />
          <Tab label="Weekly" />
          <Tab label="Monthly" />
        </Tabs>
      </Grid>

      {/* Date Select Dropdown and Date Display */}
      <Grid container  sx={{ marginTop: 2, padding: '0 16px', backgroundColor: '#607d8b',  borderRadius: 1 }}>
      <Grid item xs={12} sm={1} sx={{backgroundColor:"white"}}>
      <WSDateField
              id="date"
              name="date"
              label=""
              dateFormat="D/MM/YYYY"
              control={control}
              defaultValue={null}
              rules={{ required: false }}
            />
      </Grid>
      </Grid>

      {/* Time Grid with Half-Hour Increments up to 23:59 */}
      <Grid sx={{ overflowX: 'auto', marginTop: 2, borderRadius: 1, backgroundColor: '#607d8b' }}>
        <Grid sx={{ display: 'flex', width: 'max-content' }}>
          {timeSlots.map((time, index) => (
            <Grid 
              key={index} 
              sx={{ 
                padding: '8px 16px', 
                borderRight: index < timeSlots.length - 1 ? '1px solid #ccc' : 'none', 
                textAlign: 'center', 
                fontSize: '12px',
                color: '#fff',
                minWidth: '60px', // Adjust this value as needed
              }}
            >
              <Typography variant="body2">
                {time}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Placeholder for Schedule Content */}
      <Paper sx={{ marginTop: 1, height: 'calc(100vh - 250px)', overflowY: 'auto' }}>
        {/* Content goes here */}
      </Paper>
         {/* Footer Section */}
         <Grid 
          container
          sx={{
            position: 'fixed',
            bottom: 0,
            left: '0.5rem',
            width: '100%',
            backgroundColor: '#f5f5f5',
            textAlign: 'center',
            padding: 2,
          }}
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item xs={12} sm={4}>
            <Typography variant="body2">System Date: 11-11-2024 Monday</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="body2">Software Date: 09-10-2024 Wednesday</Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Willsoar</Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Live Support</Typography>
          </Grid>
        </Grid>
    </Grid>
  );
};
